// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { ErrorIssueStatus } from "./Shared.ErrorIssueStatus.gen";
import { ErrorSeverity } from "./Shared.ErrorSeverity.gen";

export interface IErrorIssueUpdateRequest {
	status: ErrorIssueStatus;

	resolvedInFirmwareVersion: string | undefined;

	severity: ErrorSeverity | undefined;

	notes: string | undefined;

	$type?: string | undefined;
}
export class ErrorIssueUpdateRequest {
	constructor(data?: IErrorIssueUpdateRequest) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	status: ErrorIssueStatus = 0;

	resolvedInFirmwareVersion: string | undefined;

	severity: ErrorSeverity | undefined;

	notes: string | undefined;

	static $type: string = "CoreApi.Models.ErrorIssueUpdateRequest, ";
	$type?: string | undefined = ErrorIssueUpdateRequest.$type;
}

